import type { QuoteBlock, QuoteDocumentPro } from './QuoteTypes'

export interface QuoteValidationResult {
  valid: boolean
  errors: string[]
  warnings: string[]
}

/**
 * QuoteValidator — every item must have traceable origin + productId.
 */
export class QuoteValidator {
  validateBlock(block: QuoteBlock): QuoteValidationResult {
    const errors: string[] = []
    const warnings: string[] = []

    if (!block.origin?.source) errors.push(`Bloco ${block.id}: origem ausente`)
    if (!block.origin?.productId) errors.push(`Bloco ${block.id}: productId obrigatório`)

    if (block.type === 'product') {
      if (block.origin.source !== 'comparison' && block.origin.source !== 'template') {
        errors.push(`Produto ${block.description}: origem deve ser comparison/template`)
      }
      if (!block.origin.fingerprint && block.origin.source === 'comparison') {
        warnings.push(`Produto ${block.description}: fingerprint ausente`)
      }
    }

    if (block.type === 'service' || block.type === 'labor') {
      if (!block.origin.productId.startsWith('svc:')) {
        errors.push(`Serviço ${block.description}: ID interno inválido`)
      }
    }

    if (isPriced(block) && block.quantity <= 0) {
      errors.push(`${block.description}: quantidade inválida`)
    }

    return { valid: errors.length === 0, errors, warnings }
  }

  validateDocument(doc: QuoteDocumentPro): QuoteValidationResult {
    const errors: string[] = []
    const warnings: string[] = []

    for (const block of doc.blocks) {
      const result = this.validateBlock(block)
      errors.push(...result.errors)
      warnings.push(...result.warnings)
    }

    const ids = new Set<string>()
    for (const block of doc.blocks) {
      if (ids.has(block.id)) errors.push(`ID duplicado: ${block.id}`)
      ids.add(block.id)
    }

    return { valid: errors.length === 0, errors, warnings }
  }
}

function isPriced(block: QuoteBlock): boolean {
  return block.type === 'product' || block.type === 'service' || block.type === 'labor'
}

export const quoteValidator = new QuoteValidator()
